import {Platform} from 'react-native';
import {setAttestation, setSignIn} from '../redux/slices/AuthSlice';
import {retrieveAppData} from '../utils/preference';
import {
   Attestation,
   GET_ADVERSTISEMENT,
   LastAttestation,
   timeDiff,
} from '../utils/utils';
import {
   getHeaderValueFromAsyncStorage,
   logoutHandler,
   manageUrlA,
   showTokenExpireAlertWeb,
} from './network_access';
import axios from 'axios';
import logger from '../utils/logger';

export function redirectLoggedInUser(dispatch, isLoggedIn) {
   retrieveAppData('authData')
      .then(async res => {
         if (res !== '' && res !== null && res !== undefined) {
            const data = JSON.parse(res);
            //logger({data});
            if (data.Authenticated) {
               const isAttested = await retrieveAppData(Attestation);
               const LA = await retrieveAppData(LastAttestation);
               const lastAttested = timeDiff(LA);
               dispatch(
                  setAttestation(lastAttested <= 180 ? isAttested : false),
               );
               const authState = {
                  isLoggedIn: data.Authenticated,
                  userName: data.FirstName,
                  authData: data,
                  token: data.GuidID,
                  isAttested,
               };
               if (!isLoggedIn) {
                  dispatch(setSignIn(authState));
               }
            }
         }
      })
      .catch(error => {
         logger('error::', error, false);
      });
}

export async function validateToken(dispatch, isLoggedIn) {
   if (Platform.OS === 'web') {
      if (!isLoggedIn) {
         const URL = manageUrlA(GET_ADVERSTISEMENT);
         try {
            axios
               .get(URL, {
                  headers: {
                     Token: await getHeaderValueFromAsyncStorage(),
                     'Content-Type': 'application/x-www-form-urlencoded',
                  },
               })
               .then(res => {
                  if (res) {
                     redirectLoggedInUser(dispatch, isLoggedIn);
                  }
               })
               .catch(error => {
                  logoutHandler();
               });
         } catch (error) {
            if (error?.response?.status === 500) {
               showTokenExpireAlertWeb('Internal Server Error!', 'GO_BACK');
            } else {
               logger('Error: ', {error}, false);
            }
         }
      }
   }
}
